<ppl-box-container>
  <div class="title"
       [class.underlined]="titleUnderlined">{{ title }}</div>
  <ng-content></ng-content>
</ppl-box-container>